module.exports = __webpack_public_path__ + "static/media/inmag.ad8b0d6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Seers/inmag.jpg
// module id = 141
// module chunks = 0